import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  title: {
    id: 'messageToAccountant.title',
    defaultMessage: 'Üzenet a könyvelőnek',
  },
  chatOpenHint: {
    id: 'messageToAccountant.chatOpenHint',
    defaultMessage: 'Zárd be a chatet, ha inkább üzenetet írnál a könyvelődnek.',
  },
  topicLabel: {
    id: 'messageToAccountant.topicLabel',
    defaultMessage: 'Tárgy',
  },
  topicPlaceholder: {
    id: 'messageToAccountant.topicPlaceholder',
    defaultMessage: 'Válassz...',
  },
  messageLabel: {
    id: 'messageToAccountant.messageLabel',
    defaultMessage: 'Üzenet',
  },
  messagePlaceholder: {
    id: 'messageToAccountant.messagePlaceholder',
    defaultMessage: 'Írd le az üzeneted...',
  },
  submitButton: {
    id: 'messageToAccountant.submitButton',
    defaultMessage: 'Üzenet küldése',
  },
  error: {
    id: 'messageToAccountant.error',
    defaultMessage:
      '<b>Hiba történt</b>{br}Az üzenet küldése sikertelen.{br}Ne aggódj, az üzeneted kijelentkezésig itt marad, vagy a Másolás ikonnal biztonságos helyre mentheted.{br}Kérjük, az üzenet elküldését próbáld újra később.',
  },
})
